import { z } from 'zod';
import { IsoDateTime, Uuid, Version } from './common.js';
import { DocumentSummary, DocumentType } from './documents.js';
export const ComplianceItemStatus = z.enum(['MISSING', 'UPLOADED', 'VALIDATED', 'REJECTED']);
export const ComplianceAppliesTo = z.enum(['MAIN_GUEST', 'ALL_OCCUPANTS']);
/** Exigence documentaire configurable par type de ressource (D-013, FR-CHK-06). */
export const ComplianceRequirement = z.object({
    id: Uuid,
    resourceTypeId: Uuid,
    resourceTypeCode: z.string(),
    documentType: DocumentType,
    isMandatory: z.boolean(),
    appliesTo: ComplianceAppliesTo,
    reminderAfterHours: z.number().int().nonnegative().nullable(),
    version: Version,
});
export const UpsertComplianceRequirementRequest = ComplianceRequirement.pick({
    resourceTypeId: true,
    documentType: true,
    isMandatory: true,
    appliesTo: true,
    reminderAfterHours: true,
}).partial({ isMandatory: true, appliesTo: true, reminderAfterHours: true });
/** Instance d'exigence sur une réservation. */
export const ComplianceItem = z.object({
    id: Uuid,
    reservationId: Uuid,
    occupantId: Uuid.nullable(),
    occupantName: z.string().nullable(),
    documentType: DocumentType,
    isMandatory: z.boolean(),
    status: ComplianceItemStatus,
    document: DocumentSummary.nullable(),
    validatedByName: z.string().nullable(),
    validatedAt: IsoDateTime.nullable(),
    rejectionReason: z.string().nullable(),
});
export const ReservationCompliance = z.object({
    reservationId: Uuid,
    status: z.enum(['NOT_REQUIRED', 'INCOMPLETE', 'COMPLETE']),
    items: z.array(ComplianceItem),
    missing: z.array(DocumentType),
});
export const ValidateComplianceItemRequest = z.object({ documentId: Uuid.optional() });
export const RejectComplianceItemRequest = z.object({ reason: z.string().min(5).max(500) });
/** Tâche du centre de tâches (documents manquants, paiement attendu…). */
export const TaskKind = z.enum([
    'DOCUMENT_MISSING',
    'PAYMENT_EXPECTED',
    'RESERVATION_TO_CONFIRM',
    'OPTION_EXPIRING',
    'ARRIVAL_TODAY',
    'DEPARTURE_TODAY',
    'HOUSEKEEPING',
    'MAINTENANCE',
    'OTHER',
]);
export const TaskStatus = z.enum(['OPEN', 'DONE', 'DISMISSED']);
export const Task = z.object({
    id: Uuid,
    kind: TaskKind,
    title: z.string(),
    description: z.string().nullable(),
    entityType: z.string().nullable(),
    entityId: Uuid.nullable(),
    entityReference: z.string().nullable(),
    assignedToName: z.string().nullable(),
    dueAt: IsoDateTime.nullable(),
    status: TaskStatus,
    createdAt: IsoDateTime,
    completedAt: IsoDateTime.nullable(),
});
export const ListTasksQuery = z.object({
    status: TaskStatus.default('OPEN'),
    kind: TaskKind.optional(),
    limit: z.coerce.number().int().min(1).max(100).default(25),
    cursor: z.string().optional(),
});
export const UpdateTaskRequest = z.object({
    status: TaskStatus,
    note: z.string().max(500).optional(),
});
//# sourceMappingURL=compliance.js.map